import { useContext, useMemo } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import { Button } from '@trinity/chat-components/components/presentation/Button/Button.js';
import Toast from '@trinity/chat-components/components/Toast/index.js';
import { TranscriptReplacementsContext } from '@/containers/Project.Terms';
// import { Modal, Header } from '@trinity/chat-components/Modal';
// import { ActivityBlocker } from '@/components/presentation/ActivityBlocker';
// import type { SkippedReplacements } from '@/types/transcript.cleanup';
// import { Alert } from '@trinity/chat-components/Modal/Alert';
// import { RouteLeavingGuard } from '@/components/RouteLeavingGuard';
// import { WebSocketContext, RouteGuardContext } from './Context';

export const EditHeader = () => {
  const { replacements, globalReplacements, confirmedTerms, dictionaryWords, projectId } = useContext(TranscriptReplacementsContext);
  const apiClient = useChatApiClient();
  // const { setEventKey } = useContext(WebSocketContext);

  // const [skippedReplacements, setSkippedReplacements] = useState<SkippedReplacements>();
  // const { shouldSkipGuard, setSkipGuard } = useContext(RouteGuardContext);

  const changeCount = useMemo(() => {
    return replacements.length + globalReplacements.length + confirmedTerms.length + dictionaryWords.length;
  }, [confirmedTerms, globalReplacements, replacements, dictionaryWords]);

  const saveReplacementsMutation = useMutation({
    mutationKey: ['save-transcript-replacements'],
    mutationFn: async () => {
      return await apiClient.projectsTranscripts.saveTranscriptReplacements({
        projectId,
        replacements,
        globalReplacements,
        confirmedWords: confirmedTerms,
        dictionaryWords,
      });
    },
    onError: () => {
      Toast.error({
        title: 'There was an error saving the transcripts.',
      });
    },
    onSuccess: (resp) => {
      Toast.success({
        title: 'Transcripts saved successfully.',
      });

      if (resp.async === true) {
        // TODO: Set event key for WebSocket monitoring
        // setEventKey(resp.eventKey);
        console.log('Transcript cleanup queued with eventKey:', resp.eventKey);
      }

      setTimeout(() => window.location.reload(), 1000);
    },
  });

  if (changeCount <= 0) return null;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
      <div style={{ fontWeight: 600 }}>{changeCount} Edits</div>
      <Button
        variant='pill'
        color='primary'
        onClick={() => saveReplacementsMutation.mutateAsync()}
        disabled={saveReplacementsMutation.isPending}>
        {saveReplacementsMutation.isPending ? 'Saving...' : 'Save Edits'}
      </Button>
      {/* TODO: Add RouteLeavingGuard when context is available */}
      {/*
      <RouteLeavingGuard block={changeCount > 0 && !shouldSkipGuard} checkLocation={(l, a) => a !== 'REPLACE'}>
        {guardProps => (
          <Alert
            message={`You have unsaved changes to the transcripts. Are you sure you want to navigate away without saving?`}
            open={guardProps.open}
            onClose={guardProps.closePrompt}
            onConfirm={guardProps.confirmNavigation} />
        )}
      </RouteLeavingGuard>
      */}
      {/* <SkippedReplacementsModal skippedReplacements={skippedReplacements} /> */}
      {/* {saveReplacementsMutation.isPending && <ActivityBlocker />} */}
    </div>
  );
};

/*
type SkippedReplacementsModalProps = {
  skippedReplacements: SkippedReplacements;
};

const SkippedReplacementsModal = (props: SkippedReplacementsModalProps) => {
  const supportEmail = 'support@example.com'; // TODO: Add proper support email constant

  return (
    <Modal
      open={!!props.skippedReplacements}
      blocking={true}>
      <Header>There were some replacements we were unable to apply:</Header>
      <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
        {Object.entries(props.skippedReplacements ?? {}).map(([k, replacements]) => (
          <div key={k}>
            <div>
              TranscriptId: {k}
            </div>
            <div>
              {replacements.map(r => (
                <div key={k + '-' + r.docPos.from.toString()}>
                  {`${r.expectedText} -> ${r.replacementText} (${r.docPos.from}, ${r.docPos.to})`}
                </div>
              ))}
            </div>
          </div>
        ))
        }
      </div>
      <div>{`Please refresh the page and try again. If the problem persists please contact ${supportEmail}.`}</div>
      <div>
        <Button variant='pill' onClick={() => window.location.reload()}>
          Refresh
        </Button>
      </div>
    </Modal>
  );
};
*/